module.exports = __webpack_public_path__ + "img/recall.42d94aa7.png";